import { SearchSuggestionsState } from './search-suggestions.state';
import {
  LoadSearchSuggestionsFailure,
  LoadSearchSuggestionsSuccess,
  SearchSuggestionsActionsUnion,
  SearchSuggestionsActionTypes,
  UpdateSearchHistoryTermsSuccess,
} from './search-suggestions.actions';
import { GeneralActionsUnion, UPDATE_REDUCERS_ACTION } from '~app/modules/generic/store/general.actions';


export const searchSuggestionsInitialState: SearchSuggestionsState = {
  suggestions: [],
  historyTerms: [],
  products: [],
  loading: false,
  isSuggestionsListVisible: false,
  error: null
};

export function searchSuggestionsReducer(
  state = searchSuggestionsInitialState,
  action: SearchSuggestionsActionsUnion | GeneralActionsUnion,
): SearchSuggestionsState {
  switch (action.type) {
    case SearchSuggestionsActionTypes.LOAD_SEARCH_SUGGESTIONS:
      return {
        ...state,
        loading: true
      };

    case SearchSuggestionsActionTypes.LOAD_SEARCH_SUGGESTIONS_SUCCESS:
      const { suggestions, products } = (action as LoadSearchSuggestionsSuccess).payload;
      return {
        ...state,
        suggestions,
        loading: false,
        products
      };

    case SearchSuggestionsActionTypes.LOAD_SEARCH_SUGGESTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: (action as LoadSearchSuggestionsFailure).payload.error
      };

    case SearchSuggestionsActionTypes.RESET_SUGGESTIONS:
      return {
        ...state,
        loading: false,
        suggestions: [],
        products: [],
        isSuggestionsListVisible: false,
      };

    case SearchSuggestionsActionTypes.SHOW_SUGGESTIONS_LIST:
      return {
        ...state,
        isSuggestionsListVisible: true,
      };

    case SearchSuggestionsActionTypes.HIDE_SUGGESTIONS_LIST:
      return {
        ...state,
        isSuggestionsListVisible: false,
      };

    case SearchSuggestionsActionTypes.UPDATE_SEARCH_HISTORY_TERMS_SUCCESS: {
      return {
        ...state,
        historyTerms: (action as UpdateSearchHistoryTermsSuccess).payload,
      };
    }

    case UPDATE_REDUCERS_ACTION:
      return { ...searchSuggestionsInitialState, ...state };

    default:
      return state;
  }
}
